import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import u from "./ui.module.css";

const ToastContext = createContext(null);

let toastId = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
  }, []);

  const push = useCallback(
    (message, variant = "info", duration = 4500) => {
      const id = ++toastId;
      setToasts((list) => [...list, { id, message, variant }]);
      if (duration > 0) {
        setTimeout(() => dismiss(id), duration);
      }
      return id;
    },
    [dismiss],
  );

  const toast = useMemo(
    () => ({
      success: (msg, duration) => push(msg, "success", duration),
      error: (msg, duration) => push(msg, "error", duration ?? 6000),
      info: (msg, duration) => push(msg, "info", duration),
    }),
    [push],
  );

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className={u.toastHost} aria-live="polite">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`${u.toast} ${
              t.variant === "success"
                ? u.toastSuccess
                : t.variant === "error"
                  ? u.toastError
                  : u.toastInfo
            }`}
          >
            <span className={u.toastMessage}>{t.message}</span>
            <button
              type="button"
              className={u.toastClose}
              onClick={() => dismiss(t.id)}
              aria-label="Закрыть"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
}
